class SearchFormManager {
  constructor() {
    this.forms = document.querySelectorAll('[data-search-form]');
    this.init();
  }

  init() {
    // Handle forms
    this.forms.forEach(form => {
      const input = form.querySelector('[data-search-input]');
      const reset = form.querySelector('[data-search-reset]');
      
      if (!input) return;

      // Handle input events
      input.addEventListener('input', (e) => this.handleInput(e, input, reset));
      input.addEventListener('keydown', (e) => this.handleKeyDown(e));
      
      // Handle reset button
      if (reset) {
        reset.addEventListener('click', (e) => this.handleReset(e, input));
      }

      // Handle form submission
      form.addEventListener('submit', (e) => this.handleSubmit(e, input));
    });

    // Handle search drawer input
    const drawerInput = document.querySelector('[data-search-drawer-input]');
    const drawerReset = document.querySelector('[data-search-reset]');
    const drawerForm = document.querySelector('.search-drawer-form');
    
    if (drawerInput) {
      drawerInput.addEventListener('input', (e) => this.handleDrawerInput(e, drawerInput, drawerReset));
      drawerInput.addEventListener('keydown', (e) => this.handleKeyDown(e));
      
      if (drawerReset) {
        drawerReset.addEventListener('click', (e) => this.handleDrawerReset(e, drawerInput));
      }
      
      if (drawerForm) {
        drawerForm.addEventListener('submit', (e) => this.handleDrawerSubmit(e, drawerInput));
      }
    }
  }

  handleInput(event, input, reset) {
    const value = input.value.trim();
    
    // Show/hide reset button
    if (reset) {
      if (value) {
        reset.style.display = 'flex';
        reset.style.alignItems = 'center';
        reset.style.justifyContent = 'center';
      } else {
        reset.style.display = 'none';
      }
    }

    // Ne pas ouvrir automatiquement le drawer, seulement gérer le bouton reset
    // Le drawer s'ouvrira seulement sur Enter ou clic sur la loupe
  }

  handleKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      const value = event.target.value.trim();
      if (value) {
        // Open search drawer
        this.openSearchDrawer();
        this.performPredictiveSearch(value);
      }
    }
  }

  handleReset(event, input) {
    event.preventDefault();
    input.value = '';
    input.focus();
    
    // Hide reset button
    const reset = event.target;
    reset.style.display = 'none';

    // Close search drawer
    if (window.searchDrawer) {
      window.searchDrawer.close();
    }
  }

  handleSubmit(event, input) {
    const value = input.value.trim();
    
    // Prevent submission if empty
    if (!value) {
      event.preventDefault();
      return;
    }

    // For header form, prevent submission and open search drawer
    if (input.closest('.header__search')) {
      event.preventDefault();
      this.openSearchDrawer();
      this.performPredictiveSearch(value);
    }
  }

  performPredictiveSearch(searchTerm) {
    if (!searchTerm.trim()) {
      this.clearPredictiveResults();
      return;
    }

    const resultsContainer = document.querySelector('[data-predictive-search-results]');
    if (!resultsContainer) return;

    // Check if routes are available
    if (!window.routes || !window.routes.predictive_search_url) {
      console.error('Routes not available for predictive search');
      resultsContainer.innerHTML = '<div class="predictive-search__no-results">Erreur de configuration</div>';
      return;
    }

    // Show loading state
    resultsContainer.innerHTML = '<div class="predictive-search__loading">Chargement...</div>';

    // Fetch predictive search results
    fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=predictive-search`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(text => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const results = doc.querySelector('#shopify-section-predictive-search');
        
        if (results) {
          resultsContainer.innerHTML = results.innerHTML;
        } else {
          resultsContainer.innerHTML = '<div class="predictive-search__no-results">Aucun résultat trouvé</div>';
        }
      })
      .catch(error => {
        console.error('Predictive search error:', error);
        resultsContainer.innerHTML = '<div class="predictive-search__no-results">Erreur lors de la recherche</div>';
      });
  }

  clearPredictiveResults() {
    const resultsContainer = document.querySelector('[data-predictive-search-results]');
    if (resultsContainer) {
      resultsContainer.innerHTML = '';
    }
  }

  openSearchDrawer() {
    const drawer = document.querySelector('[data-search-drawer]');
    if (drawer) {
      drawer.classList.add('search-drawer--open');
      document.body.classList.add('search-drawer-open');
      document.body.style.overflow = 'hidden';
      
      // Focus the search input
      const input = drawer.querySelector('[data-search-drawer-input]');
      if (input) {
        setTimeout(() => input.focus(), 100);
      }
    }
  }

  handleDrawerInput(event, input, reset) {
    const value = input.value.trim();
    
    // Show/hide reset button
    if (reset) {
      if (value) {
        reset.style.display = 'flex';
        reset.style.alignItems = 'center';
        reset.style.justifyContent = 'center';
      } else {
        reset.style.display = 'none';
      }
    }

    if (value.length > 0) {
      this.performPredictiveSearch(value);
    } else {
      this.clearPredictiveResults();
    }
  }

  handleDrawerReset(event, input) {
    event.preventDefault();
    input.value = '';
    input.focus();
    
    // Hide reset button
    const reset = event.target;
    reset.style.display = 'none';
    
    this.clearPredictiveResults();
  }

  handleDrawerSubmit(event, input) {
    const value = input.value.trim();
    
    // Prevent submission if empty
    if (!value) {
      event.preventDefault();
      return;
    }

    // Let form submit normally for search drawer
    return true;
  }


}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new SearchFormManager(); 
});